import React, { useState } from 'react';
import FooterActa from '../../../components/FooterActa';
import HeaderActaAdultos from '../../../components/headerActasAdultos';
import moment from 'moment';
import types from '../../../services/types';
import HeaderActa from '../../../components/headerActas';


const AsignaturasPerdidasActa = ({course, showSemi}) => {
  // Aquí podrías obtener tus datos dinámicamente, por ejemplo, a través de props o un fetch call
  const [todayDay, setTodayDay] = useState(moment());

  const getMes = (mes) =>{
    switch(mes){
        case "1":return "Enero";
        case "2":return "Febrero";
        case "3":return "Marzo";
        case "4":return "Abril";
        case "5":return "Mayo";
        case "6":return "Junio";
        case "7":return "Julio";
        case "8":return "Agosto";
        case "9":return "Septiembre";
        case "10":return "Octubre";
        case "11":return "Noviembre";
        case "12":return "Diciembre";
        default:return "Enero";
    }
}

 const cargarAsignaturas =  (student) => {
        const subjectArray = [];
        student.areasNotes.forEach(a =>{
            a.subjectNotes.forEach(s =>{
                if(!subjectArray.find(sb=>sb.schoolSubjetId === s.schoolSubjetId))
                {
                    subjectArray.push(s);
                }
            });
        });
        return subjectArray
    }

  return (
    <>
    <div className="col-md-3 mb-2 non-printable">
            <label htmlFor="txtAsistenciaDate" className="col-form-label  text-sm-right">Fecha Informe: </label>
            <input
                id="txtAsistenciaDate"
                type="date"
                className="form-control "
                value={todayDay.format("yyyy-MM-DD")}
                onChange={(e) => setTodayDay(moment(e.target.value))}/>
    </div>
    <div className="card">
      <h1 className='non-printable'>Reporte de asignaturas perdidas</h1>
      <p className='non-printable'>Selecciona los filtros para generar el reporte.</p>
      <br></br>
      <div className="card acta-container">
        {showSemi && (
          <HeaderActaAdultos />
        )}

        {!showSemi && (
          <HeaderActa />
        )}
      
      <section className="incidencia-implicados">
        <h5 className="section-title">S.I.E</h5>
        <h5 className="section-title">ACTA DE FINALIZACIÓN DE PERÍODO</h5>     
      
        <p>En la ciudad de Barranquilla, siendo los {moment(todayDay).format("DD \\d\\í\\a\\s \\d\\e\\l \\m\\e\\s \\d\\e ")} {getMes(String(todayDay.month()+1))} {todayDay.format(" \\d\\e YYYY")}, se cita a los acudientes del grado <strong>{course.gradeName}</strong>, con el fin de entregar <strong>INFORME DEL {course.periodName} ACADÉMICO</strong> quienes mostraron las siguientes dificultades en distintos aspectos de su formación en la asignaturas o áreas que se detallan a continuación:</p>
        <p>En consecuencia, es necesario encausar acciones que conlleven a mejorar los aspectos relacionados como faltas o dificultades a nivel académico y convivencial y asumir los roles que como institución y Familia Corresponden para superar estas dificultades presentadas durante el periodo.</p>
        <p>La familia, representada por el acudiente, padre o madre, se compromete a:</p>
        <ol>
          <li>Velar por el cumplimiento estricto de las normas y reglas convivenciales, especialmente las relacionadas con la representación personal, puntualidad y uso de tecnologías prohibidas</li>
          <li>Seguir diariamente el trabajo independiente en casa que cada estudiante debe cumplir para afianzar lo aprendido en el aula de clase.</li>
          <li>Intensificar la atención y seguimiento en el desempeño académico en las asignaturas o áreas, en las que el estudiante presentó dificultades durante el período.</li>
          <li>Realizar y presentar de forma correcta y puntual los planes de mejoramiento de cada una de las asignaturas con bajo rendimiento para poder recuperarlas</li>
        </ol>
        
      
      {/* Código para la tabla de estudiantes y notas */}
      <section className="academic-areas escala-valorativa-container">
          <h5 className="historico-title">FIRMA DE LOS ACUDIENTES</h5>
          <table className="table table-custom-boletin">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Cant.</th>
            <th>Asignatura</th>
            <th>Nota</th>
            <th>Firma Estudiante</th>
            <th>Firma Acudiente</th>
          </tr>
        </thead>
        <tbody>
          {course.students?.map(student => 
            {
              const asignaturas = cargarAsignaturas(student);
              return asignaturas.map((asignatura, index) => 
              (<tr key={`${student.studentFullName}-${asignatura.schoolSubjetName}`}>
                    {index === 0 && (
                      <>
                        <td rowSpan={asignaturas.length}>{student.studentFullName}</td>
                        <td rowSpan={asignaturas.length}>{asignaturas.length}</td>
                      </>
                    )}
                
                    <td>{asignatura.schoolSubjetName}</td>
                    <td>{asignatura.note}</td>
                    {index === 0 && (
                      <>
                        <td rowSpan={asignaturas.length}></td>
                        <td rowSpan={asignaturas.length}></td>
                      </>
                    )}
                  </tr>
                ))
            }
          )}
        </tbody>
      </table>
        </section>

    </section>
      <FooterActa  creadorId={course.tutorId??0}
                   reportTypeId={types.reportTypes.ACTAFINALPERIODO}></FooterActa>
      </div>
    </div>
    <br />
                    <button className="btn btn-primary center display-block" onClick={() => window.print()}>Imprimir</button>
                <br />
    </>
  );
};

export default AsignaturasPerdidasActa;
